import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import type { PalantirAvatarShape, PalantirAvatarSize } from './avatar.type';
import { PalantirAvatarShapeEnum, PalantirAvatarSizeEnum } from './avatar.type';

@Component({
  selector: 'palantir-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class PalantirAvatarComponent implements AfterViewInit {
  @ViewChild('avatar') public avatar: ElementRef<HTMLDivElement> | null = null;

  @Input() public shape?: PalantirAvatarShape = PalantirAvatarShapeEnum.avatar;

  @Input() public size?: PalantirAvatarSize = PalantirAvatarSizeEnum['3xs'];

  @Input() public fallbackText?: string;

  public ngAfterViewInit(): void {
    if (!this.avatar?.nativeElement) return;

    const element = this.avatar.nativeElement;

    const icon = element.querySelector('palantir-icon');
    if (icon) return;

    const img = element.querySelector('img');
    const fallbackText = this.fallbackText ?? element.textContent;

    if (img) {
      img.addEventListener('error', () => this.setFallback(fallbackText));
    } else {
      this.setFallback(fallbackText);
    }
  }

  private setFallback(text?: string | null): void {
    if (!this.avatar?.nativeElement) return;

    const initials = (text?.trim() ?? '')
      .replaceAll(/[^\d\sa-z]/gi, '')
      .split(' ')
      .map((word) => word[0]?.toUpperCase())
      .filter(Boolean)
      .slice(0, 2);

    if (initials.length === 0) {
      initials.push('?');
    }

    this.avatar.nativeElement.innerHTML = `<span>${initials.join('')}</span>`;
  }
}
